import styled from "styled-components";

export const IconContainer = styled("span")`
  display: relative;
  margin-right: 8px;
  color: ${(props) => props.theme.colors.main};
`;
